import { memo } from 'react'
import Image from 'next/image'
import { applyImagePolicy } from '@/utils/imageExtension'

type ProductDetailBannersProps = {
  productBanners: string[]
}

const prepareUrl = (url: string) => (url ? applyImagePolicy(url) : null)

export const ProductDetailBanners = memo(
  ({ productBanners }: ProductDetailBannersProps) => {
    return (
      <>
        {productBanners?.length
          ? productBanners.map((banner) => {
              const srcBanner = prepareUrl(banner)
              return (
                <Image
                  key={JSON.stringify(banner)}
                  src={srcBanner}
                  width={728}
                  height={60}
                  unoptimized
                />
              )
            })
          : null}
      </>
    )
  }
)
